import { render, staticRenderFns } from "./QualityChip.vue?vue&type=template&id=1c235ae5&scoped=true"
import script from "./QualityChip.vue?vue&type=script&lang=js"
export * from "./QualityChip.vue?vue&type=script&lang=js"
import style0 from "./QualityChip.vue?vue&type=style&index=0&id=1c235ae5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c235ae5",
  null
  
)

export default component.exports